import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";

export const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: ${spacing[4]};
  @media (min-width: 48rem) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
  }
`;
export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[3]};
  min-width: 0;
`;
export const Control = styled.div`
  min-width: 12rem;
`;

/** The preview column: stays in view while the controls beside it scroll. */
export const StickyColumn = styled(Column)`
  @media (min-width: 48rem) {
    position: sticky;
    top: 0;
    align-self: start;
  }
`;
